const translations = {
    maxError: 'Max Characters: {{max}}',
    minError: 'Min Characters: {{min}}',
    patternMismatch: 'Invalid Input'
};

export default translations;
